import React from 'react';
import { Button, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from '@heroui/react';
import { useTranslations } from '../contexts/translation.context';
import IcArrow from '../client/Arrow-Right.svg';

type LanguageSwitcherVariant = 'solid' | 'ghost';

interface LanguageSwitcherProps {
  variant?: LanguageSwitcherVariant;
  className?: string;
}

const variantClasses: Record<LanguageSwitcherVariant, string> = {
  solid:
    'px-0.5 md:px-4 md:py-2.5 h-5 md:h-10 rounded-none md:rounded-3 leading-5 bg-transparent md:bg-tin text-auth-ink text-sm font-semibold flex items-center gap-1.5 md:gap-2 min-w-0',
  ghost:
    'px-4 py-2.5 h-10 rounded-3 leading-5 bg-transparent text-auth-ink text-sm font-semibold flex items-center gap-2 min-w-0',
};

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  variant = 'solid',
  className = '',
}) => {
  const { t, lang, changeLanguage } = useTranslations();

  return (
    <Dropdown
      classNames={{
        base: 'w-[5.625rem] md:w-auto',
        content: 'max-md:min-w-0',
      }}
    >
      <DropdownTrigger>
        <Button
          endContent={<img src={IcArrow} alt={t('alt.arrow')} />}
          className={`${variantClasses[variant]} ${className}`.trim()}
          style={{ boxShadow: 'none' }}
        >
          {lang?.toUpperCase()}
        </Button>
      </DropdownTrigger>
      <DropdownMenu aria-label={t('aria.languageSelect')}>
        <DropdownItem key="ru" onClick={() => changeLanguage('ru')}>
          RU
        </DropdownItem>
        <DropdownItem key="en" onClick={() => changeLanguage('en')}>
          EN
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
